/* Church Sign Shop — "upload & print" product page (yard signs, A-frame
   inserts). Sibling of configurator.js, deliberately separate: these products
   have no design library, no colors and no footer — just size, sides, a file
   and a quantity. Shares the renderer (sign-templates.js) and the PDF writer
   (sign-pdf.js) with the greeting-sign configurator, so bleed, the print
   check and the CNC alignment dots behave identically.

   Sizes come from the section's blocks (label, trim size, mark positions),
   are registered as shapes on SignTemplates, and map to Shopify variants by
   option value. */
(function () {
  "use strict";

  var root = document.querySelector("[data-uprint]");
  if (!root || !window.SignTemplates || !window.SignPDF) return;
  var ST = window.SignTemplates;

  var MIN_PPI_OK = 75;    /* below this an upload is blocked */
  var MIN_PPI_GOOD = 150; /* at/above this it's flagged good */

  /* ── CONFIG ───────────────────────────────────────────────────────── */
  var CFG = { sizes: [], sidesMode: "variant", print: { dpi: 150, cropTicks: true } };
  try {
    var cfgEl = root.querySelector("[data-uprint-config]");
    var parsed = JSON.parse((cfgEl && cfgEl.textContent) || "{}");
    if (Array.isArray(parsed.sizes)) CFG.sizes = parsed.sizes;
    if (parsed.sidesMode) CFG.sidesMode = parsed.sidesMode;
    if (parsed.print) {
      if (parsed.print.dpi) CFG.print.dpi = parseInt(parsed.print.dpi, 10) || 150;
      CFG.print.cropTicks = parsed.print.cropTicks !== false;
    }
  } catch (e) { /* defaults */ }
  if (!CFG.sizes.length) return;

  /* register each size as a shape the renderer understands */
  CFG.sizes.forEach(function (s, i) {
    s.key = "up" + i;
    ST.SHAPES[s.key] = { wIn: s.wIn, hIn: s.hIn, circle: false, label: s.label };
  });

  /* ── STATE ────────────────────────────────────────────────────────── */
  var state = {
    sizeIdx: 0,
    sides: CFG.sidesMode === "pair" ? "double" : "single",
    uploads: [null, null],
    approved: false,
    qty: 1,
    generating: false
  };

  function size() { return CFG.sizes[state.sizeIdx]; }
  function shapeKey() { return size().key; }
  function bleed() { return size().bleedIn; }
  function isDouble() { return state.sides === "double"; }
  function sideCount() { return isDouble() ? 2 : 1; }

  /* ── ELEMENTS ─────────────────────────────────────────────────────── */
  var stepEls = {};
  root.querySelectorAll("[data-step]").forEach(function (el) { stepEls[el.getAttribute("data-step")] = el; });
  var unitEl = root.querySelector("[data-unit]");
  var totalEl = root.querySelector("[data-total]");
  var configEl = root.querySelector("[data-config]");
  var addBtn = root.querySelector("[data-addbtn]");
  var addLabel = root.querySelector("[data-addlabel]");
  var cartForm = root.querySelector("[data-cart-form]");
  var variantIdInput = root.querySelector("[data-variant-id]");
  var qtyInput = root.querySelector("[data-qty-input]");
  var approveRow = root.querySelector("[data-approve-row]");
  var approveBox = root.querySelector("[data-approve]");
  var sidesDeltaEl = root.querySelector("[data-sides-delta]");
  var printFileFront = root.querySelector("[data-print-file-front]");
  var printFileBack = root.querySelector("[data-print-file-back]");
  var previewFileFront = root.querySelector("[data-preview-file-front]");
  var previewFileBack = root.querySelector("[data-preview-file-back]");
  var props = {};
  root.querySelectorAll("[data-prop]").forEach(function (el) { props[el.getAttribute("data-prop")] = el; });

  function money(n) { return "$" + n.toFixed(2); }

  /* ── VARIANT / PRICE ──────────────────────────────────────────────── */
  function variantFor(sizeIdx, sides) {
    var s = CFG.sizes[typeof sizeIdx === "number" ? sizeIdx : state.sizeIdx];
    var vs = (s && s.variants) || {};
    if (CFG.sidesMode === "variant") return vs[sides || state.sides] || vs.only || null;
    return vs.only || vs.single || null;
  }
  function matchedVariant() { return variantFor(); }
  function price() {
    var v = matchedVariant();
    return v && typeof v.price === "number" ? v.price / 100 : 0;
  }
  function qty() { return Math.max(1, parseInt(state.qty, 10) || 1); }
  function configStr() {
    var parts = [size().label];
    if (CFG.sidesMode === "pair") parts.push("Set of 2 inserts");
    else if (CFG.sidesMode === "variant") parts.push(isDouble() ? "Double Sided" : "Single Sided");
    return parts.join(" · ");
  }

  /* ── PREFLIGHT ────────────────────────────────────────────────────── */
  function ppiBadge(ppi) {
    if (ppi >= MIN_PPI_GOOD) return { cls: "good", label: "GREAT RESOLUTION" };
    if (ppi >= MIN_PPI_OK) return { cls: "ok", label: "OK — SLIGHTLY SOFT UP CLOSE" };
    return { cls: "low", label: "TOO LOW TO PRINT" };
  }

  function preflight(idx) {
    var u = state.uploads[idx];
    var panel = root.querySelector('[data-uz-preflight="' + idx + '"]');
    if (!panel) return;
    var cv = panel.querySelector("[data-uz-canvas]");
    var statsEl = panel.querySelector("[data-uz-stats]");
    if (!u || !u.img) { panel.hidden = true; return; }

    var s = size(), b = bleed();
    u.ppi = ST.uploadPpi(u.img.width, u.img.height, shapeKey(), b);

    var ppi = 440 / (s.wIn + 2 * b);
    cv.width = Math.round((s.wIn + 2 * b) * ppi);
    cv.height = Math.round((s.hIn + 2 * b) * ppi);
    ST.renderUpload({ ctx: cv.getContext("2d"), img: u.img, shape: shapeKey(), bleedIn: b, ppi: ppi, guides: true });

    var tW = s.wIn + 2 * b, tH = s.hIn + 2 * b;
    var imgAspect = u.img.width / u.img.height, tAspect = tW / tH;
    var kept = imgAspect > tAspect ? (tAspect / imgAspect) : (imgAspect / tAspect);
    var lossPct = Math.round((1 - kept) * 100);
    var badge = ppiBadge(u.ppi);

    var html = '<span class="pdp-pf-badge pdp-pf-badge--' + badge.cls + '">' + badge.label + "</span>";
    if (u.isPdf && u.img.pageWIn) {
      var pw = Math.round(u.img.pageWIn * 100) / 100, ph = Math.round(u.img.pageHIn * 100) / 100;
      html += '<span class="pdp-pf-line">PDF page ' + pw + '" × ' + ph + '" scaled to fill a ' +
              s.label + " (incl. " + b + '" bleed) — rendered at print resolution</span>';
    } else {
      html += '<span class="pdp-pf-line">' + u.img.width + " × " + u.img.height +
              "px → " + Math.round(u.ppi) + " DPI on a " + s.label + " (incl. " + b + '" bleed)</span>';
    }
    if (lossPct > 2) {
      html += '<span class="pdp-pf-line pdp-pf-line--warn">Your image proportions don’t match the sign — about ' +
              lossPct + "% will be trimmed off the " + (imgAspect > tAspect ? "sides" : "top/bottom") +
              ". Check the dashed cut line in the preview.</span>";
    }
    if (badge.cls === "low") {
      html += '<span class="pdp-pf-line pdp-pf-line--err">This file is below ' + MIN_PPI_OK +
              " DPI at print size and would look blurry. Please upload a larger file (" +
              Math.ceil(tW * MIN_PPI_OK) + " × " + Math.ceil(tH * MIN_PPI_OK) + "px or more).</span>";
    } else {
      html += '<span class="pdp-pf-line">Anything inside the dashed line prints; the outer ' + b + '" is bleed for cutting.</span>';
    }
    statsEl.innerHTML = html;
    panel.hidden = false;
  }

  function repreflightAll() {
    state.uploads.forEach(function (u, i) { if (u && u.img) preflight(i); });
  }

  /* ── PDF UPLOADS — rasterize page 1 with pdf.js (loaded on demand) ─── */
  var PDFJS_SRC = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js";
  var PDFJS_WORKER = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";
  var PDF_RASTER_PPI = 200;
  var pdfjsLoading = null;
  function loadPdfJs() {
    if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
    if (pdfjsLoading) return pdfjsLoading;
    pdfjsLoading = new Promise(function (resolve, reject) {
      var s = document.createElement("script");
      s.src = PDFJS_SRC;
      s.onload = function () {
        if (!window.pdfjsLib) { reject(new Error("pdf.js failed to load")); return; }
        window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS_WORKER;
        resolve(window.pdfjsLib);
      };
      s.onerror = function () { reject(new Error("pdf.js failed to load")); };
      document.head.appendChild(s);
    });
    return pdfjsLoading;
  }

  /* pdf.js doesn't expose Bleed/TrimBox — read them from the raw bytes so a
     print export's slug marks don't end up printed on the sign. */
  function readPdfBoxes(buf) {
    var txt = "";
    var bytes = new Uint8Array(buf);
    var limit = Math.min(bytes.length, 400000);
    for (var i = 0; i < limit; i++) txt += String.fromCharCode(bytes[i]);
    function box(name) {
      var m = new RegExp(name + "\\s*\\[([^\\]]*)\\]").exec(txt);
      if (!m) return null;
      var n = m[1].trim().split(/\s+/).map(parseFloat);
      return n.length === 4 && n.every(function (v) { return !isNaN(v); }) ? n : null;
    }
    return { bleed: box("BleedBox"), trim: box("TrimBox"), media: box("MediaBox") };
  }

  function rasterizePdf(file) {
    return file.arrayBuffer().then(function (buf) {
      var boxes = readPdfBoxes(buf);
      return loadPdfJs().then(function (pdfjsLib) {
        return pdfjsLib.getDocument({ data: buf }).promise;
      }).then(function (doc) {
        return doc.getPage(1);
      }).then(function (page) {
        var vp1 = page.getViewport({ scale: 1 });
        var scale = PDF_RASTER_PPI / 72;
        var vp = page.getViewport({ scale: scale });
        var crop = boxes.bleed || boxes.trim || null;
        var media = boxes.media || [0, 0, vp1.width, vp1.height];
        var cropW = crop ? (crop[2] - crop[0]) : vp1.width;
        var cropH = crop ? (crop[3] - crop[1]) : vp1.height;
        var offX = crop ? (crop[0] - media[0]) : 0;
        var offY = crop ? (media[3] - crop[3]) : 0;

        var cv = document.createElement("canvas");
        cv.width = Math.round(cropW * scale);
        cv.height = Math.round(cropH * scale);
        var ctx = cv.getContext("2d");
        ctx.fillStyle = "#FFFFFF";
        ctx.fillRect(0, 0, cv.width, cv.height);
        var vpShifted = page.getViewport({ scale: scale, offsetX: -offX * scale, offsetY: -offY * scale });
        return page.render({ canvasContext: ctx, viewport: vpShifted }).promise.then(function () {
          cv.pageWIn = cropW / 72;
          cv.pageHIn = cropH / 72;
          return cv;
        });
      });
    });
  }

  /* ── UPLOAD ZONES ─────────────────────────────────────────────────── */
  function zoneEls(idx) {
    var zone = root.querySelector('[data-uploadzone="' + idx + '"]');
    return zone ? {
      zone: zone,
      input: zone.querySelector("[data-uz-input]"),
      btn: zone.querySelector("[data-uz-btn]"),
      btnLabel: zone.querySelector("[data-uz-btnlabel]"),
      name: zone.querySelector("[data-uz-name]"),
      remove: zone.querySelector("[data-uz-remove]"),
      thumb: zone.querySelector("[data-uz-thumb]"),
      preview: zone.querySelector("[data-uz-preview]")
    } : null;
  }

  function acceptFile(idx, file) {
    if (!file) return;
    var isPdf = /pdf$/i.test(file.type) || /\.pdf$/i.test(file.name);
    if (!isPdf && !/^image\/(png|jpeg)$/.test(file.type)) {
      window.alert("Please upload a PDF, JPG or PNG file.");
      return;
    }
    var els = zoneEls(idx);
    if (els && els.btnLabel) els.btnLabel.textContent = "READING FILE…";

    function done(img, thumbSrc) {
      state.uploads[idx] = { file: file, img: img, isPdf: isPdf, name: file.name };
      if (els) {
        if (els.btnLabel) els.btnLabel.textContent = "REPLACE FILE";
        if (els.name) els.name.textContent = file.name;
        if (els.thumb) els.thumb.classList.add("is-file");
        if (els.preview && thumbSrc) { els.preview.src = thumbSrc; els.preview.style.display = "block"; }
      }
      state.approved = false;
      if (approveBox) approveBox.checked = false;
      preflight(idx);
      render();
    }

    if (isPdf) {
      rasterizePdf(file).then(function (cv) {
        done(cv, cv.toDataURL("image/jpeg", 0.7));
      }).catch(function (err) {
        console.warn("PDF read failed:", err);
        window.alert("We couldn't read that PDF. Please export it again, or upload a JPG or PNG instead.");
        if (els && els.btnLabel) els.btnLabel.textContent = "CLICK TO UPLOAD";
      });
    } else {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () { done(img, url); };
      img.onerror = function () {
        window.alert("We couldn't read that image. Please try another file.");
        if (els && els.btnLabel) els.btnLabel.textContent = "CLICK TO UPLOAD";
      };
      img.src = url;
    }
  }

  function clearUpload(idx) {
    state.uploads[idx] = null;
    var els = zoneEls(idx);
    if (els) {
      if (els.input) els.input.value = "";
      if (els.btnLabel) els.btnLabel.textContent = "CLICK TO UPLOAD";
      if (els.name) els.name.textContent = "";
      if (els.thumb) els.thumb.classList.remove("is-file");
      if (els.preview) { els.preview.removeAttribute("src"); els.preview.style.display = ""; }
    }
    var panel = root.querySelector('[data-uz-preflight="' + idx + '"]');
    if (panel) panel.hidden = true;
    state.approved = false;
    if (approveBox) approveBox.checked = false;
    render();
  }

  [0, 1].forEach(function (idx) {
    var els = zoneEls(idx);
    if (!els) return;
    els.btn.addEventListener("click", function () { els.input.click(); });
    els.input.addEventListener("change", function () { acceptFile(idx, els.input.files[0]); });
    els.remove.addEventListener("click", function () { clearUpload(idx); });
    ["dragenter", "dragover"].forEach(function (ev) {
      els.zone.addEventListener(ev, function (e) { e.preventDefault(); els.zone.classList.add("is-drag"); });
    });
    ["dragleave", "drop"].forEach(function (ev) {
      els.zone.addEventListener(ev, function (e) { e.preventDefault(); els.zone.classList.remove("is-drag"); });
    });
    els.zone.addEventListener("drop", function (e) {
      if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) acceptFile(idx, e.dataTransfer.files[0]);
    });
  });

  /* ── READY / RENDER ───────────────────────────────────────────────── */
  function uploadsReady() {
    for (var i = 0; i < sideCount(); i++) {
      var u = state.uploads[i];
      if (!u || !u.img) return false;
      if (u.ppi && u.ppi < MIN_PPI_OK) return false;
    }
    return true;
  }
  function ready() { return uploadsReady() && state.approved && !!matchedVariant() && !state.generating; }

  function render() {
    /* size + sides cards */
    root.querySelectorAll("[data-option]").forEach(function (btn) {
      var opt = btn.getAttribute("data-option");
      var val = btn.getAttribute("data-value");
      var on = opt === "size" ? String(state.sizeIdx) === val : state.sides === val;
      btn.classList.toggle("is-selected", on);
    });

    /* second upload zone only when there are two printed sides */
    var zone2 = root.querySelector('[data-uploadzone="1"]');
    if (zone2) zone2.hidden = !isDouble();
    var pf2 = root.querySelector('[data-uz-preflight="1"]');
    if (pf2 && !isDouble()) pf2.hidden = true;
    if (!isDouble() && state.uploads[1]) state.uploads[1] = null;

    if (approveRow) approveRow.hidden = !uploadsReady();

    /* double-sided upcharge, from the real variant prices */
    if (sidesDeltaEl && CFG.sidesMode === "variant") {
      var vs = variantFor(state.sizeIdx, "single");
      var vd = variantFor(state.sizeIdx, "double");
      var delta = vs && vd ? (vd.price - vs.price) / 100 : 0;
      sidesDeltaEl.hidden = !(delta > 0);
      if (delta > 0) sidesDeltaEl.textContent = "+" + money(delta).replace(/\.00$/, "");
    }

    /* step completion ticks */
    function tick(key, done) {
      var el = stepEls[key];
      if (!el) return;
      var n = el.querySelector("[data-stepnum]");
      if (n) n.classList.toggle("pdp-stephead__num--complete", !!done);
    }
    tick("size", true);
    tick("sides", true);
    tick("upload", uploadsReady() && state.approved);
    tick("qty", true);

    /* price */
    var p = price(), q = qty();
    if (configEl) configEl.textContent = configStr();
    if (unitEl) unitEl.textContent = money(p) + " × " + q;
    if (totalEl) totalEl.textContent = money(p * q);

    var ok = ready();
    if (addBtn) { addBtn.classList.toggle("is-ready", ok); addBtn.disabled = !ok; }
    if (addLabel) {
      addLabel.textContent = state.generating ? "PREPARING PRINT FILE…" : (ok ? "ADD TO CART" : "FINISH CHOOSING");
    }

    /* form fields */
    var mv = matchedVariant();
    if (variantIdInput && mv) variantIdInput.value = mv.id;
    if (qtyInput) qtyInput.value = q;
    if (props["Size"]) props["Size"].value = size().label;
    if (props["Sides"]) {
      props["Sides"].value = CFG.sidesMode === "single" ? "Single Sided"
        : (isDouble() ? (CFG.sidesMode === "pair" ? "Set of 2 inserts" : "Double Sided") : "Single Sided");
    }
    if (props["Artwork"]) {
      props["Artwork"].value = state.uploads.slice(0, sideCount())
        .map(function (u) { return u ? u.name : ""; }).filter(Boolean).join(" · ");
    }
  }

  /* ── EVENTS ───────────────────────────────────────────────────────── */
  root.querySelectorAll("[data-option]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var opt = btn.getAttribute("data-option");
      var val = btn.getAttribute("data-value");
      if (opt === "size") {
        state.sizeIdx = parseInt(val, 10) || 0;
        state.approved = false;
        if (approveBox) approveBox.checked = false;
        repreflightAll();
      } else if (opt === "sides") {
        state.sides = val;
        state.approved = false;
        if (approveBox) approveBox.checked = false;
      }
      render();
    });
  });

  if (approveBox) {
    approveBox.addEventListener("change", function () { state.approved = approveBox.checked; render(); });
  }

  var qtyTiles = root.querySelectorAll("[data-qty]");
  var qtyCustomTile = root.querySelector("[data-qty-custom]");
  var qtyCustomRow = root.querySelector("[data-qty-customrow]");
  var qtyCustomInput = root.querySelector("[data-qty-custominput]");
  qtyTiles.forEach(function (tile) {
    tile.addEventListener("click", function () {
      state.qty = parseInt(tile.getAttribute("data-qty"), 10) || 1;
      qtyTiles.forEach(function (t) { t.classList.toggle("is-active", t === tile); });
      if (qtyCustomTile) qtyCustomTile.classList.remove("is-active");
      if (qtyCustomRow) qtyCustomRow.hidden = true;
      render();
    });
  });
  if (qtyCustomTile) {
    qtyCustomTile.addEventListener("click", function () {
      qtyTiles.forEach(function (t) { t.classList.remove("is-active"); });
      qtyCustomTile.classList.add("is-active");
      if (qtyCustomRow) qtyCustomRow.hidden = false;
      if (qtyCustomInput) qtyCustomInput.focus();
    });
  }
  if (qtyCustomInput) {
    qtyCustomInput.addEventListener("input", function () {
      state.qty = Math.max(1, parseInt(qtyCustomInput.value, 10) || 1);
      render();
    });
  }

  /* ── PRINT FILES ──────────────────────────────────────────────────── */
  function canvasToJpeg(canvas) {
    return new Promise(function (resolve, reject) {
      canvas.toBlob(function (blob) {
        if (!blob) { reject(new Error("toBlob failed")); return; }
        blob.arrayBuffer().then(function (buf) {
          resolve({ jpeg: new Uint8Array(buf), pxW: canvas.width, pxH: canvas.height });
        }, reject);
      }, "image/jpeg", 0.9);
    });
  }

  function renderPrintPage(idx) {
    var s = size(), b = bleed(), ppi = CFG.print.dpi;
    var cv = document.createElement("canvas");
    cv.width = Math.round((s.wIn + 2 * b) * ppi);
    cv.height = Math.round((s.hIn + 2 * b) * ppi);
    ST.renderUpload({ ctx: cv.getContext("2d"), img: state.uploads[idx].img,
                      shape: shapeKey(), bleedIn: b, ppi: ppi, guides: false });
    return canvasToJpeg(cv);
  }

  function jobJson(job) {
    return JSON.stringify({
      v: 1, product: CFG.handle || "", job: job,
      size: size().wIn + "x" + size().hIn + "in",
      trim: [size().wIn, size().hIn], bleedIn: bleed(), sides: state.sides,
      files: state.uploads.slice(0, sideCount()).map(function (u) { return u ? u.name : null; })
    });
  }

  function generatePdfs(job) {
    var s = size(), b = bleed();
    var jobs = [];
    for (var i = 0; i < sideCount(); i++) {
      (function (idx) {
        jobs.push(renderPrintPage(idx).then(function (page) {
          return {
            side: idx === 0 ? "front" : "back",
            blob: window.SignPDF.build({
              trimWIn: s.wIn, trimHIn: s.hIn, bleedIn: b,
              pages: [page],
              marks: {
                enabled: s.marks && s.marks.length > 0,
                squareIn: s.markSquareIn || 0.451,
                dotIn: s.markDotIn || 0.25,
                positions: s.marks || []
              },
              cropTicks: CFG.print.cropTicks,
              title: "Church Sign Shop — " + configStr() + " — " + (idx === 0 ? "FRONT" : "BACK"),
              subject: jobJson(job)
            })
          };
        }));
      })(i);
    }
    return Promise.all(jobs);
  }

  /* Cart thumbnail: the finished sign, trimmed, as a small PNG. */
  var PREVIEW_PX = 600;
  function renderPreviewPng(idx) {
    var s = size(), b = bleed();
    var cv = document.createElement("canvas");
    var cssW = PREVIEW_PX * (s.wIn >= s.hIn ? 1 : s.wIn / s.hIn);
    ST.renderPreviewInto(cv, cssW, {
      shape: shapeKey(), bleedIn: b, dpr: 1, cornerRadiusIn: s.radiusIn || 0,
      drawFull: function (ctx, ppi) {
        ST.renderUpload({ ctx: ctx, img: state.uploads[idx].img, shape: shapeKey(), bleedIn: b, ppi: ppi, guides: false });
      }
    });
    return new Promise(function (resolve) {
      cv.toBlob(function (blob) { resolve(blob); }, "image/png");
    });
  }

  function attachFile(blob, input, name, type) {
    if (!input || !blob || typeof DataTransfer === "undefined") return false;
    try {
      var file = new File([blob], name, { type: type });
      var dt = new DataTransfer();
      dt.items.add(file);
      input.disabled = false;
      input.files = dt.files;
      return input.files.length === 1;
    } catch (e) {
      console.warn("Could not attach print file:", e);
      return false;
    }
  }

  function makeJobCode() {
    var chars = "ABCDEFGHJKMNPQRSTUVWXYZ23456789";
    var out = "";
    var rnd = new Uint8Array(6);
    (window.crypto || window.msCrypto).getRandomValues(rnd);
    for (var i = 0; i < 6; i++) out += chars[rnd[i] % chars.length];
    return out;
  }

  /* ── ADD TO CART ──────────────────────────────────────────────────── */
  var hasForm = cartForm && cartForm.tagName === "FORM";
  function submitWithPrintFile() {
    if (!ready() || !hasForm) return;
    state.generating = true;
    render();

    var job = makeJobCode();
    if (props["Job"]) { props["Job"].value = job; props["Job"].disabled = false; }

    var timedOut = false;
    var watchdog = new Promise(function (resolve) {
      setTimeout(function () { timedOut = true; resolve(null); }, 30000);
    });

    if (previewFileFront) previewFileFront.disabled = true;
    if (previewFileBack) previewFileBack.disabled = true;

    var previewsP = Promise.all([0, 1].slice(0, sideCount()).map(function (i) {
      return renderPreviewPng(i).then(function (blob) {
        attachFile(blob, i === 0 ? previewFileFront : previewFileBack,
                   job + "-" + (i === 0 ? "front" : "back") + "-preview.png", "image/png");
      });
    })).catch(function (err) { console.warn("Cart preview failed:", err); });

    var slug = (size().slug || "sign");
    Promise.race([Promise.all([generatePdfs(job), previewsP]).then(function (r) { return r[0]; }), watchdog])
      .then(function (results) {
        if (!results) {
          if (props["printStatus"]) {
            props["printStatus"].value = "generation timed out — customer artwork is attached to the order";
            props["printStatus"].disabled = false;
          }
          return;
        }
        var ok = true;
        results.forEach(function (r) {
          var input = r.side === "back" ? printFileBack : printFileFront;
          var attached = attachFile(r.blob, input, job + "-" + slug + "-" + r.side + ".pdf", "application/pdf");
          if (!attached) ok = false;
        });
        if (!ok && props["printStatus"]) {
          props["printStatus"].value = "print file could not be attached in this browser";
          props["printStatus"].disabled = false;
        }
      })
      .catch(function (err) {
        console.warn("Print file generation failed:", err);
        if (props["printStatus"]) {
          props["printStatus"].value = "generation failed: " + (err && err.message ? err.message : "unknown");
          props["printStatus"].disabled = false;
        }
      })
      .then(function () {
        if (printFileBack && !isDouble()) printFileBack.disabled = true;
        if (timedOut) console.warn("Print generation timed out; submitting anyway.");
        cartForm.submit();
      });
  }

  if (addBtn) {
    addBtn.addEventListener("click", function (e) {
      e.preventDefault();
      submitWithPrintFile();
    });
  }

  /* ── INIT ─────────────────────────────────────────────────────────── */
  (function init() {
    var params = new URLSearchParams(window.location.search);
    var wantSize = params.get("size");
    if (wantSize) {
      CFG.sizes.forEach(function (s, i) {
        if (s.slug === wantSize || s.optionValue === wantSize) state.sizeIdx = i;
      });
    }
    if (CFG.sidesMode === "variant" && params.get("sides") === "double") state.sides = "double";
    render();
  })();
})();
